module.exports = __webpack_public_path__ + "img/me-night-top-bg_ar.7d24ec68.png";